import { render, staticRenderFns } from "./BaseAlertSystem.vue?vue&type=template&id=40bb8770&"
import script from "./BaseAlertSystem.vue?vue&type=script&lang=js&"
export * from "./BaseAlertSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports